// extracted by mini-css-extract-plugin
module.exports = {"sticky-range":"sticky-range--3fFj12","stickyRange":"sticky-range--3fFj12","sticky-element":"sticky-element--d_W2Z0","stickyElement":"sticky-element--d_W2Z0"};